
/**
 * 分类接口服务（纯接口请求）
 * 仅负责调用后端分类接口，返回原始响应，不处理任何数据
 */
export const categoryService = {
  /**
   * 获取所有分类列表
   * @returns {Promise<Response>} 后端原始响应
   */
  getCategories: ({homeShow = ''}) => {
    return fetch(`/qhkj-agri-map-api/base/category/allList?homeShow=${homeShow}&type=CATEGORY`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
};